module.exports = __webpack_public_path__ + "static/geerntet-01-661de8a714364e6a659853f78769372f.jpg";